var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderRightwardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.82857 4.63087L3.68571 2.09312C3.40318 1.86499 3 2.08203 3 2.46225L3 7.53775C3 7.91798 3.40318 8.13501 3.68571 7.90688L6.82857 5.36913C7.05714 5.18456 7.05714 4.81544 6.82857 4.63087Z",
    fill: "#C6D0D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderRightwardIcon);
export default __webpack_public_path__ + "static/media/FolderRightwardIcon.d8224ff9a65083911a85dd9d6f0b4ffe.svg";
export { ForwardRef as ReactComponent };